export const MAX_SENTENCES = Number(process.env.REACT_APP_MAX_SENTENCES || 10);
export const APP_URL = process.env.REACT_APP_URL;
// export const API_BASE_URL = "https://africanlanguagesphrasebook-1.onrender.com";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

// Debug logging to help diagnose the issue
//console.log('Environment variables loaded:');
//console.log('REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
//console.log('REACT_APP_STRIPE_PUBLIC_KEY:', process.env.REACT_APP_STRIPE_PUBLIC_KEY);
//console.log('STRIPE_PUBLIC_KEY constant:', STRIPE_PUBLIC_KEY);

export const colors = [
  { bg: "#9e2a2a", text: "#ffffff" },
  { bg: "#333333", text: "#ffffff" },
  { bg: "#2f6b42", text: "#ffffff" },
];
